module.exports = __webpack_public_path__ + "static/media/coachChatArtwork.0866efb5.svg";